import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Leftbar from "./Components/Leftbar";
import { MessageSquare, Monitor, Bell } from "lucide-react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import NotificationComponent from "./Components/NewNotificationComponent";
import AlertComponent from "./Components/AlertComponent";
import ConnectivityComponent from "./Components/ConnectivityComponent";
import { useSelector } from "react-redux";

const Settings = () => {
  const [activeTab, setActiveTab] = useState(1);
  const auth = useSelector((state) => state.auth);
  const { permissions } = auth?.user?.user_permissions || {}
  return (
    <div className="px-[14px] py-[14px] w-full">
      <Tab.Container className="w-full" id="left-tabs-example" defaultActiveKey={activeTab}>
        <div className="h-screen_h_83 gap-[20px] grid grid-cols-12 ">
          <div className="bg-[#ffffff] rounded-lg p-[7px] col-span-2 h-[calc(100vh-117px)]">
            <Nav className="flex-column gap-2 w-full">
              <Nav.Item
                className="h-[50px] w-full flex items-center rounded border-l-4 border-[#FEC601]"
                style={{
                  background: activeTab == 1 ? "rgba(254, 198, 1, 0.21)" : "",
                }}
              >
                <Nav.Link className="w-full" eventKey="1" onClick={() => setActiveTab(1)}>
                  <div className='flex items-center gap-2 font-["Roboto"] font-medium text-[18px] text-[#000]'>
                    <MessageSquare /> Notification
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                className="h-[50px] w-full flex items-center rounded border-l-4 border-[#FEC601]"
                style={{
                  background: activeTab == 2 ? "rgba(254, 198, 1, 0.21)" : "",
                }}
              >
                <Nav.Link className="w-full" eventKey="2" onClick={() => setActiveTab(2)}>
                  <div className='flex items-center gap-2 font-["Roboto"] font-medium text-[18px] text-[#000]'>
                    <Bell /> Alert
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item
                className="h-[50px] w-full flex items-center rounded border-l-4 border-[#FEC601]"
                style={{
                  background: activeTab == 3 ? "rgba(254, 198, 1, 0.21)" : "",
                }}
              >
                <Nav.Link className="w-full" eventKey="3" onClick={() => setActiveTab(3)}>
                  <div className='flex items-center gap-2 font-["Roboto"] font-medium text-[18px] text-[#000]'>
                    <Monitor /> Connectivity
                  </div>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-span-10">
            <Tab.Content>
              <Tab.Pane eventKey="1">
                <NotificationComponent permissions={permissions} />
              </Tab.Pane>
              <Tab.Pane eventKey="2">
                <AlertComponent permissions={permissions} />
              </Tab.Pane>
              <Tab.Pane eventKey="3">
                <ConnectivityComponent permissions={permissions} />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </div>
      </Tab.Container>
    </div>
  );
};

export default Settings;
